export default "__VITE_ASSET__Ck9w_h30__"